"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FavoriteFill;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function FavoriteFill(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "favorite-fill"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M92.746,33.474c0-.023,0-.043,0-.058A24.8,24.8,0,0,0,67.976,8.645,24.524,24.524,0,0,0,50,16.41,24.524,24.524,0,0,0,32.024,8.645,24.8,24.8,0,0,0,7.253,33.416c0,.021,0,.042,0,.063-.1,2.007-.691,29.737,40.892,57.317l.115.088a2.5,2.5,0,0,0,1.462.471c.068,0,.135,0,.2-.008.019,0,.037-.01.055-.012a2.528,2.528,0,0,0,.26.02c.069,0,.136,0,.2-.008a2.524,2.524,0,0,0,1.293-.471l.058-.043C93.474,63.216,92.847,35.435,92.746,33.474Z"
  }))));
}